import { render, staticRenderFns } from "./CompanyWatermark.vue?vue&type=template&id=70b4ffe3&scoped=true&"
import script from "./CompanyWatermark.vue?vue&type=script&lang=js&"
export * from "./CompanyWatermark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b4ffe3",
  null
  
)

export default component.exports